export default "__VITE_ASSET__CvMsePdA__"